import {
  Box,
  Card,
  Button,
  CardContent,
  CardMedia,
  Checkbox,
  Grid,
  Radio,
  Typography,
  Link,
} from "@mui/material";
import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
//   import { ResultSlider } from './ResultSlider';
import { styled } from "@mui/material/styles";
import img from "./AllMenuCard.png";

import GradeIcon from "@mui/icons-material/Grade";
import { IMAGE_URL } from "config";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#2B817B",
    },
  },
});
const Sdrawer = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    display: "block",
  },
}));
const FavCards = ({ filterFavourite }) => {
  // -------------------- radio check
  const [selectedValue, setSelectedValue] = React.useState("");
  const [value1, setValue1] = React.useState("");
  const [getDietry, setgetDietry] = React.useState("");
  const [subscription, setSubscription] = React.useState(false);

  const handleChange1 = (event) => {
    setValue1(event.target.value);
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChangeDietry = (event) => {
    setgetDietry(event.target.value);
  };
  const handleChangesubs = (event) => {
    setSubscription(event.target.checked);
  };
  const setDefault = (event) => {
    setValue1(event.target.value);
    setSelectedValue(event.target.value);
    setgetDietry(event.target.value);
    setSubscription(event.target.checked);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  const controlProps1 = (item) => ({
    checked: value1 === item,
    onChange: handleChange1,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  const controlPropsDietry = (item) => ({
    checked: getDietry === item,
    onChange: handleChangeDietry,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  // --------------
  const resetbtn = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // padding: '14px 48px',
    width: "190px",
    height: "34px",
    background: "#FFFFFF",
    border: "1px solid #559A95",
    color: "#559A95",
    borderRadius: "6px",
    margin: " 0px auto",
  };
  const inlineStyleRated = {
    padding: "7px 18px",
    fontFamily: "Outfit",
    width: "139px",
    height: "25px",
    left: "0px",
    top: "52px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E1E1E6",
    borderRadius: "42px 0px 0px 42px",
  };
  const inlineStyleRated2 = {
    padding: "7px 18px",
    fontFamily: "Outfit",
    width: "139px",
    height: "25px",
    left: "0px",
    top: "52px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E1E1E6",
    borderRadius: "0px 42px 42px 0px",
  };
  //                -----------------

  const minDistance = 30;
  const [value, setValue] = React.useState([1, 40]);

  const handleChangeSlider = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
    console.log(value);
  };
  function valuetext(value) {
    return `${value}`;
  }
  console.log(valuetext(null));
  return (
    <div className="container-lg">
      <div className="container-lg sResultSepr">
        <Box sx={{ margin: "15px", }}>
          <Grid container spacing={2}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: { xs: "block" },
                // border: "1px solid red"
              }}
            >
              <Box>
                <Box>
                  <Grid container spacing={1}>
                    {filterFavourite?.map((items) => {
                      console.log("items", items)
                      return (
                        <Grid item lg={6} xs={12} md={12} key={items.index} minWidth={400}>
                          <Card
                            sx={{
                              display: "flex",
                              flexDirection: {
                                lg: "row",
                                md: "row",
                                sm: "row",
                                xs: "column",
                              },
                              height: { lg: 168, md: 170, sm: 180, xs: "auto" },
                              // maxWidth: "100%",
                              // border: "1px solid red"
                            }}
                          >
                            <CardMedia
                              component="img"
                              alt="green iguana"
                              height="168"
                              sx={{
                                width: {
                                  lg: 200,
                                  md: 180,
                                  sm: 200,
                                  xs: "auto",
                                },
                                objectFit: "cover",
                              }}
                              image={IMAGE_URL + items?.image}
                            />

                            <CardContent>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: 12,
                                  fontFamily: "Outfit",
                                  color: "#559A95",
                                  fontStyle: "normal",
                                }}
                                gutterBottom
                              >
                                {items.cuisine} Cusine
                              </Typography>
                              <Typography
                                gutterBottom
                                variant="body1"
                                component="div"
                                sx={{
                                  fontSize: 15,
                                  fontFamily: "Outfit",
                                  color: "#1A1824",
                                  fontStyle: "normal",
                                }}
                              >
                                {items?.name}
                              </Typography>
                              <Box sx={{ display: "flex" }}>
                                <i
                                  style={{ color: "#FAA641" }}
                                  class="fa-sharp fa-solid fa-star"
                                ></i>
                                <span
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "Outfit",
                                    color: "#FAA641",
                                    fontStyle: "normal",
                                    marginRight: 9,
                                  }}
                                >
                                  4.7
                                </span>
                                <img
                                  alt=""
                                  src="./AllMenuCard.png"
                                  style={{
                                    width: 40,
                                    borderRadius: 10,
                                    marginRight: 10,
                                    objectFit: "cover",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "Outfit",
                                    color: "#9EA3AE",
                                    fontStyle: "normal",
                                  }}
                                >
                                  {items.onwer}{" "}
                                </span>
                              </Box>
                              <Typography
                                variant="body2"
                                style={{
                                  fontSize: 10,
                                  fontFamily: "Outfit",
                                  color: "#9EA3AE",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  marginTop: 5,
                                }}
                              >
                                {items?.description}
                                {/* Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry . . . . */}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Box>
            </Grid>
            {/* <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: { xs: "block" },
              }}
            >
              <Box>
                <Box>
                  <Grid container spacing={1}>
                    {[1, 2, 3].map((items) => {
                      return (
                        <Grid item xs={12} md={12} key={items.index}>
                          <Card
                            sx={{
                              display: "flex",
                              flexDirection: {
                                lg: "row",
                                md: "row",
                                sm: "row",
                                xs: "column",
                              },
                              height: { lg: 168, md: 220, sm: 168, xs: "auto" },
                            }}
                          >
                            <CardMedia
                              component="img"
                              alt="green iguana"
                              height="168"
                              sx={{
                                width: {
                                  lg: 280,
                                  md: 280,
                                  sm: 280,
                                  xs: "auto",
                                },
                                objectFit: "cover",
                              }}
                              image={img}
                            />

                            <CardContent>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: 12,
                                  fontFamily: "Outfit",
                                  color: "#559A95",
                                  fontStyle: "normal",
                                }}
                                gutterBottom
                              >
                                Arabian Cusine
                              </Typography>
                              <Typography
                                gutterBottom
                                variant="body1"
                                component="div"
                                sx={{
                                  fontSize: 15,
                                  fontFamily: "Outfit",
                                  color: "#1A1824",
                                  fontStyle: "normal",
                                }}
                              >
                                Chicken and Broccoli Rice Casserole
                              </Typography>
                              <Box sx={{ display: "flex" }}>
                                <i
                                  style={{ color: "#FAA641" }}
                                  class="fa-sharp fa-solid fa-star"
                                ></i>
                                <span
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "Outfit",
                                    color: "#FAA641",
                                    fontStyle: "normal",
                                    marginRight: 9,
                                  }}
                                >
                                  4.7
                                </span>
                                <img
                                  alt=""
                                  src="./AllMenuCard.png"
                                  style={{
                                    width: 40,
                                    borderRadius: 10,
                                    marginRight: 10,
                                    objectFit: "cover",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "Outfit",
                                    color: "#9EA3AE",
                                    fontStyle: "normal",
                                  }}
                                >
                                  Chef Juna Food{" "}
                                </span>
                              </Box>
                              <Typography
                                variant="body2"
                                style={{
                                  fontSize: 10,
                                  fontFamily: "Outfit",
                                  color: "#9EA3AE",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  marginTop: 5,
                                }}
                              >
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry . . . .
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default FavCards;

{
  /* <FormControl>
                                                      <RadioGroup 
                                               row
                                              aria-labelledby="demo-controlled-radio-buttons-group"
                                              name="controlled-radio-buttons-group"
                                              value={value1}
                                              onChange={handleChange1}
                                              >
                                              <FormControlLabel value="month" defaultChecked control={<Radio />} label="MONTH" />
                                              <FormControlLabel value="male" control={<Radio />} label="Male" />
                                          </RadioGroup>
                                      </FormControl> */
}
